<div class="insured-card">
    <div class="insured-card-accent"></div>

    <div class="insured-card-icon">
        <img src="resources/assets/images/branch/buildings.svg" alt="Inmueble" class="insured-card-icon-img">
    </div>

    <div class="insured-card-divider"></div>

    <div class="insured-card-body">
        <div class="insured-field">
            <span class="insured-label">Tipo:</span>
            <span class="insured-value">Inmueble</span>
        </div>
        <div class="insured-field">
            <span class="insured-label">Domicilio:</span>
            <span class="insured-value">{{data.address}}</span>
        </div>
        <div class="insured-field">
            <span class="insured-label">Población:</span>
            <span class="insured-value">{{data.province}}</span>
        </div>
        <div class="insured-field" *ngIf="(null !== data.rentAmouth) && (undefined !== data.rentAmouth)">
            <span class="insured-label">Alquiler:</span>
            <span class="insured-value">{{data.rentAmouth}}</span>
        </div>
    </div>
</div>
